import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/AxiosConfig';

// Async thunk: Insert
export const insertProjectstaffData = createAsyncThunk(
  'projectstaff/insert',
  async (staffData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/project_staffs', staffData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

// Async thunk: Update
export const updateProjectStaffData = createAsyncThunk(
  'projectstaff/update',
  async ({ id, staffData }, { rejectWithValue }) => {
    try {
      
      const requestData = {
        Project_staff_data: staffData.Project_staff_data.map(staff => ({
          t_user_id: staff.t_user_id,
          role_cd: staff.role_cd,
          unit_price: staff.unit_price || 0
        }))
      };
      
      const response = await axios.put(`/api/project_staffs/${id}`, requestData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

// Async thunk: Fetch single project staff by ID
export const fetchProjectStaffById = createAsyncThunk(
  'projectstaff/fetchById',
  async (t_project_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/project_staffs/${t_project_id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);

export const getProjectMemberData = createAsyncThunk(
  'projectstaff/getProjectMemberData',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/project_staffs/ProjectMemberData/${id}`);
      return response.data;
    } catch (error) {
      // Optional: return custom error message or data
      return rejectWithValue(error.response?.data || 'Failed to fetch project member data');
    }
  }
);

// Slice
const projectStaffSlice = createSlice({
  name: 'projectstaff',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Insert
      .addCase(insertProjectstaffData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertProjectstaffData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(insertProjectstaffData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateProjectStaffData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProjectStaffData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateProjectStaffData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch by ID
      .addCase(fetchProjectStaffById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectStaffById.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchProjectStaffById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //
        builder
    .addCase(getProjectMemberData.pending, (state) => {
      state.status = 'loading'
      state.message = null;
      state.error = null
    })
    .addCase(getProjectMemberData.fulfilled, (state, action) => {
      state.status = 'succeeded'
      state.projectMemberData = action.payload.data;
    })
    .addCase(getProjectMemberData.rejected, (state, action) => {
      state.status = 'failed'
      state.message = action.payload?.message
      state.error = action.payload?.errors
    }); 
  },
});

export default projectStaffSlice.reducer;
